import React from 'react';
import * as styles from './detailedCurriculum.module.scss';
import ProjectCard from './ProjectCard';
import { MINI_PROJECT_DETAILS } from './projectDetailsData';

const MiniProjects = () => {
  return (
    <section id="mini-projects">
      <div className={styles.wrap}>
        <h2 className={styles.secH}>
          Part 1 — <span className={styles.g}>mini projects.</span>
        </h2>
        <p className={styles.secSub}>
          Small, focused builds of 4–5 hours each. Every one ends in a working, deployed artifact
          and a measured result. They exist to build the muscle before the guided projects.
        </p>
        {MINI_PROJECT_DETAILS.map((p) => (
          <ProjectCard p={p} key={p.id} />
        ))}
      </div>
    </section>
  );
};

export default MiniProjects;
